<template>
  <div class="extra-card">
    <div class="extra--wrapper">
      <div class="extra-header">
        <span v-if="!!promoLabel" class="promo-label">{{promoLabel}}</span>
        <img v-lazy="`${picture}`">
      </div>
      <div class="infoextra"><h6 class="no-wrap">{{name}}</h6>
        <div class="price">{{price | decimalPrice}} € {{type}}</div>
        <div class="flex-element">
          <div class="addextra btn-std card-button" @click="handleClickAdd" v-if="!isSelected">{{$t('extras.list.add')}}</div>
          <div class="addextra add-extra--reverse btn-std card-button" @click="handleClickAdd" v-else-if="!needRemoveBtn">{{$t('extras.list.edit')}}</div>
          <div class="addextra add-extra--reverse btn-std card-button" @click="handleClickRemove" v-else>{{$t('extras.list.delete')}}</div>
          <div class="btnsee btn-std card-button"  @click="handleClickInfo">
            <div class="icon">
              <img src="/static/img/btnsee.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <card-extra-picker
      :extra="item"
      :start-date="startDate"
      :end-date="endDate"
      :nb-guest="nbGuest"
      :nb-day="dayCount"
      ref="picker"
      v-on:extra-change="handleExtraChange"
    />
  </div>

</template>

<script>
  import CardExtraPicker from "./card-extra-picker";
  import moment from 'moment';

  export default {
    name: "extra-main-widget",
    components: {CardExtraPicker},
    props: {
      item: Object,
      startDate: String,
      endDate: String,
      nbGuest: Number
    },
    methods: {
      handleClickAdd(e) {
        if (!this.$refs.picker) {
          return;
        }
        this.$refs.picker.open();
      },
      handleClickRemove() {
        this.$emit('extra-change', {extra: this.item, value: []});
      },
      handleClickInfo(e) {
        this.$emit('click-add', e);
      },
      handleExtraChange(value) {
        this.$emit('extra-change', {extra: this.item, value});
      }
    },
    computed: {
      dayCount () {
        return Math.abs(moment(this.endDate.substr(0, 10)).diff(moment(this.startDate.substr(0, 10)), 'day'));
      },
      needRemoveBtn() {
        if (this.item.type === 'ONCE') {
          return this.isSelected;
        }
        if (this.item.type === 'FIRSTDBOOK') {
          return this.isSelected;
        }
        if (this.item.type === 'LASTDBOOK') {
          return this.isSelected;
        }
        if (this.item.type === 'DAY') {
          return this.dayCount === 1;
        }
        return false;
      },
      promoLabel() {
        if (!this.item.discount) {
          return '';
        }
        if (this.item.discount.type === 'NEW') {
          return this.$t('extras.discount.NEW');
        }
        if (this.item.discount.type === 'FIX') {
          return this.$t('extras.discount.FIX', this.item.discount.amount.amount / 100);
        }
        if (this.item.discount.type === 'PERCENT') {
          return this.$t('extras.discount.PERCENT', this.item.discount.amount.amount);
        }
      },
      picture() {
        return `${this.item.picture}?w=520&h=400&crop-to-fit`;
      },
      name() {
        return this.item.text.name;
      },
      inputPrice() {
        return this.item.price.amount;
      },
      price () {
        return this.inputPrice
      },
      type() {
        return this.$t('extras.type.' + this.item.type);
      },
      isSelected() {
        // return true;
        if (this.$store.state.shoppingCart.booking.bookingRoom.bookingRoom) {
          for (const infos of this.$store.state.shoppingCart.booking.bookingRoom.bookingRoom.extras) {
            if (infos.is_option) continue;
            if (infos.extra.id === this.item.id) {
              return true;
            }
          }
        }
        return false;
      }
    },
  }
</script>





// WEBPACK FOOTER //
// src/pages/tunnel/step3/extra-main-widget.vue